
import { Vue, Component, Prop } from 'vue-property-decorator'
import { patchUser } from '@/utils/user'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'ToggleIsEnabled',
    components: { DialogTemplate },
})
export default class ToggleIsEnabled extends Vue {
    @Prop({ required: true }) props!: any
    loading = false

    get user() {
        return this.props.user
    }

    get toEnable(): boolean {
        return !this.user.isEnabled
    }

    async toggleEnabled() {
        if (!this.user) return

        try {
            this.loading = true
            const payload = {
                id: this.user.id,
                isEnabled: this.toEnable,
            }
            const newUser = await patchUser(this.user.id, payload)
            this.$emit('close', newUser)
        } finally {
            this.loading = false
        }
    }
}
